<template>
  <account-settings />
</template>

<script>
import AccountSettings from "@/components/3pl/Settings/AccountSettings/index";
export default {
  components: {
    AccountSettings,
  },
};
</script>

<style></style>
